import React, { useEffect } from "react";
import { connect } from "react-redux";
import { deleteAppointmentCategory, getAllAppointmentCategories } from "../../../redux/Actions/AppointmentActions";
import DeleteModal from "../../Modal/DeleteModal";

const DeleteCategory = (props) => {
  const { deleteCategory, isDeleting, deleteSuccess, id, getCategories } =
    props;

  useEffect(
    () => {
      if (deleteSuccess) {
        props.closeModal();
        getCategories(1, 10);
      }
    }, // eslint-disable-next-line
    [deleteSuccess]
  );

  const handleDelete = (id) => {
    deleteCategory(id);
  };

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Delete this category?"}
      width={"463px"}
      text={"Delete"}
      onClick={() => handleDelete(id)}
      disabled={isDeleting}
      isLoading={isDeleting}
      loadingText={"Deleting..."}
      children={
        "Once you delete this category, it won’t be possible to undo this action. Delete category?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isDeleting: state.appointment.isDeletingCategory,
  deleteSuccess: state.appointment.deleteSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  deleteCategory: (id) => dispatch(deleteAppointmentCategory(id)),
  getCategories: (page, limit) => dispatch(getAllAppointmentCategories(page, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCategory);
